import type { JSONValue } from '#ui-shared/types/json';

export class Base64Utils {
  static toBase64(data: unknown): string {
    const json = JSON.stringify(data);
    const utf8 = new TextEncoder().encode(json);

    let bin = '';
    const chunk = 0x8000;

    for (let i = 0; i < utf8.length; i += chunk) {
      bin += String.fromCharCode(...utf8.subarray(i, i + chunk));
    }

    return btoa(bin);
  }

  static fromBase64(base64: string): string {
    const binaryString = atob(base64);

    const uInt8Array = Uint8Array.from(binaryString, char => char.charCodeAt(0));

    return new TextDecoder().decode(uInt8Array);
  }

  /**
   * Attempts to parse JSON from the base64-encoded data.
   * @param base64
   * @returns a valid JSON, typed as `JSONValue`
   * @throws `SyntaxError` if the JSON is invalid
   */
  static fromBase64ToJsonOrThrow(base64: string): JSONValue {
    return JSON.parse(Base64Utils.fromBase64(base64));
  }

  /**
   * Attempts to convert a base-64 encoded string into a valid File, based on the provided content type. Will throw if the base-64 string is invalid.
   * @param base64
   * @param contentType
   * @returns a valid `File`
   */
  // TODO: Implement narrower type for images
  static fromBase64ToImageOrThrow(base64: string, contentType: string): File {
    const bytes = Uint8Array.from(atob(base64), char => char.charCodeAt(0));

    return new File(
      [bytes],
      'image',
      { type: contentType },
    );
  }
}
